// Generated by scripts/update-seeq-icons.js from src/svg/seeq/seeq-datalab.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcSeeqDatalab = {
  prefix: 'fak',
  iconName: 'seeq-datalab' as IconName,
  icon: [
    939,
    1024,
    [],
    'e910',
    'M931 906.7l-251.6-579.1v-219.2c26.7-3.2 48.5-25.9 48.6-54.2s-21-50.1-48.6-54.2h-419.8c-26.7 4-48.5 26.7-48.5 54.2s21 51 48.5 54.2v219.2l-250.7 579.1c-12.1 25.1-11.3 53.4 3.2 77.7 14.6 25.1 41.3 39.6 69.6 39.6h776.5c29.1 0 55-14.6 69.5-39.6 14.6-24.3 15.4-52.6 3.3-77.7zM123.8 914.8l245.8-564.6h-0.8v-241h202.2v241l245.1 564.6h-692.3z',
  ],
} satisfies IconDefinition;
